import { ILanguage, ILookup, LookupType } from '@app/types';
import { IAppState } from 'store';

export const selectRootState = (state: IAppState) => state.root;

export const selectGlobalMesasge = (state: IAppState) => selectRootState(state).globalMessage;

export const selectInitialized = (state: IAppState) => selectRootState(state).initialized;

// Guarded like selectLookup below: appInitializeSaga dispatches
// appInitializeSuccess without waiting for fetchLanguages/fetchLookups to come
// back, so the app can render for a moment with these still null — on a first
// visit, or whenever nothing was restored from local storage.
export const selectLanguages = (state: IAppState): ILanguage[] => {
  const rootState = selectRootState(state);

  if (!rootState.languages) {
    return [];
  }

  return rootState.languages.data || [];
};

export const selectLookup = (state: IAppState, lookupType: LookupType): ILookup[] => {
  const rootState = selectRootState(state);

  if (!rootState.lookups) {
    return [];
  }

  return rootState.lookups.data[lookupType] || [];
};
